export default function generateToast(app, variant, text, addErrorTitle = false, customTitle = '') {

  if (addErrorTitle) {
    const h = this.$createElement

    if (text) {
      text = [h(
        'p',
        [
          app.$t('global.anErrorHasOccurred')
        ]
      ),
      h(
        'p',
        [
          h('strong', 'Hata Detayı : '),
          `${text}`,
        ]
      )]
    }
    else {
      text = [h(
        'p',
        [
          app.$t('global.anErrorHasOccurred')
        ]
      )]
    }
  }
  else {
    if (text == undefined) {
      text = app.$t('global.anErrorHasOccurred')
    }
  }

  app.$bvToast.toast(text, {
    title: `${customTitle != '' ? customTitle : app.$t(`global.${(variant == 'success' ? 'success' : 'error')}`)
      }`,
    variant: variant,
    solid: true,
  })

  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
